import request from "@/utils/request";

export function refreshUserInfo() {
  return request({
    url: 'userInfo/refresh',
    method: 'post',
  })
}
